import React from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import InputMask from 'react-input-mask';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';
import { normalizeDate } from '../Utils/GlobalUtils';

import HeadlinePanel from '../Components/HeadlinePanel';
import Loading from '../Components/Loading';

import miniTable from '../styles/MiniTables.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as CheckIcon } from '../icons/check.svg';
import InputRegionSelector from '../Components/InputSpecialFields/InputRegionSelector';

export default function EditApplicant({ action }) {
    const { id } = useParams();
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    
    const [formInfo, setFormInfo] = React.useState({
        id: '',
        name: '',
        description: '',
    });

    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-full-info-applicant?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                const newData = response.data;
                setFormInfo((prev) => {
                    const updated = { ...prev };
                    for (const key in newData) {
                        if (newData[key] !== null && newData[key] !== undefined) {
                            updated[key] = newData[key];
                        }
                    }
                    return updated;
                });
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.value;

        setStatus(<p>Сохраните изменения</p>);
    
        setFormInfo((prev) => ({ ...prev, [field]: value }));
    
        setErrorsForm((prevErrors) => {
          if (!prevErrors[field]) return prevErrors;
          const updatedErrors = { ...prevErrors };
          delete updatedErrors[field];
          return updatedErrors;
        });
    };
    
    const [errorsForm, setErrorsForm] = React.useState({});
    const validateForm = () => {
        const newErrors = {};

        if (!formInfo.name) {
            newErrors.name = 'Обязательное поле';
        }
        if (formInfo.name && (formInfo.name.length < 2 || formInfo.name.length > 150)) {
            newErrors.postal_address = 'Значение не может быть меньше 2 и более 150 символов';
        }

        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addNewDebtor = () => {
        const token = localStorage.getItem('token');

        axios.post('/api/add-new-applicant', {
            name: formInfo.name,
            description: formInfo.description,
        },
        {
            headers: {
            Authorization: `Bearer ${token}`
            }
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Заявитель добавлен', 'success');
            navigate('/registers');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            setStatus(<a className='mainLabelError'>Данные не сохранены</a>);
        });
    };

    const changeDebtor = () => {
        const token = localStorage.getItem('token');

        axios.put('/api/change-applicant', {
            id: formInfo.id,
            name: formInfo.name,
            description: formInfo.description,
        },
        {
            headers: {
            Authorization: `Bearer ${token}`
            }
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Данные изменены', 'success');
            navigate(`/applicant/${formInfo.id}`);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            setStatus(<a className='mainLabelError'>Данные не сохранены</a>);
        });
    };

    const handleSave = () => {
        if (validateForm()) {
            if (action=='add') {
                addNewDebtor();
            } 
            if (action=='change') {
                changeDebtor();
            }
        }
    };

    const pageLabels = {
        add: 'Добавление заявителя',
        change: 'Редактирование сведений о заявителе',
    };

    return (
        <div className='mainContainer'>
            <HeadlinePanel 
                label={pageLabels[action] || 'Действия над сведениями о заявителе'}
                type='Назад' 
            />
            <div className='containerInner'>
                <div className='pageWrapper'>
                    <div className='pageLimiter'>
                    <h3 className='formHeadline'>Основная информация</h3>
                    <div className='labelInputWrapper'>
                        <a className='label'>ФИО или наименование</a>
                        <div className='labelInputRight'>
                            <input 
                                type='text' 
                                value={formInfo.name} 
                                onChange={handleChange('name')} 
                                className={errorsForm.name ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='150' 
                                disabled={action=='change'} 
                            />
                            {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                        </div>
                    </div>

                    <div style={{height: '20px'}}></div>

                    <h3 className='formHeadline'>Дополнительное</h3>

                    <div className='labelInputWrapper'>
                        <a className='label'>Примечание</a>
                        <div className='labelInputRight'>
                            <div>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.description}  
                                    onChange={handleChange('description')}
                                    minLength='' 
                                    maxLength='900' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{formInfo.description.length}/900</p>
                            </div>
                            {errorsForm.description && <div className='errorUnderInput'>{errorsForm.description}</div>}
                        </div>
                    </div>

                    <div className='panelFormConfirmation'>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={handleSave}
                        >
                            {action=='add' && 'Добавить'}
                            {action=='change' && 'Сохранить'}
                        </button>
                        {status && <div>{status}</div>}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
